// extracted by mini-css-extract-plugin
module.exports = {"image":"MainImage_image__7YOX8"};